import { Box, ClickAwayListener, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { EllipsisVertical, Pen, Trash } from 'lucide-react';
import { ProspectCollectionDto } from '@zaplify/services/prospect-collections/shared';
import { useState } from 'react';

export const ProspectCollectionTile = ({
    prospectCollectionDto,
    onRename,
    onDelete,
    onClick,
}: {
    prospectCollectionDto: ProspectCollectionDto;
    onRename: () => void;
    onDelete: () => void;
    onClick: () => void;
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
    };

    const handleRename = (e) => {
        onRename();
        handleClose(e);
    };

    const handleDelete = (e) => {
        onDelete();
        handleClose(e);
    };

    return (
        <>
            <Box
                sx={{
                    padding: '16px',
                    margin: '16px 0',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: '#f9f9f9',
                    width: '300px',
                    minWidth: '300px',
                    display: 'flex',
                    flexDirection: 'column',
                    '& :hover': {
                        cursor: 'pointer',
                    },
                }}
                onClick={onClick}
                key={prospectCollectionDto.id}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '8px',
                        width: '100%',
                        flexDirection: 'row',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '16px',
                            fontWeight: 500,
                            lineHeight: '24px',
                            color: '#3A4B59',
                        }}
                    >
                        {prospectCollectionDto.name}
                    </Typography>
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'inline-block',
                        }}
                    >
                        <IconButton
                            sx={{
                                paddingX: '8px',
                                color: '#3A4B59',
                                margin: 0,
                            }}
                            onClick={handleClick}
                        >
                            <EllipsisVertical strokeWidth={1} />
                        </IconButton>
                    </Box>
                </Box>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '21px',
                        color: '#3A4B59',
                    }}
                >
                    {prospectCollectionDto.prospectIds.length} prospects
                </Typography>
            </Box>
            <ClickAwayListener onClickAway={handleClose}>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={{
                        marginTop: '32px',
                        '& .MuiTypography-root': {
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '21px',
                            color: '#3A4B59',
                            marginLeft: '8px',
                        },
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <MenuItem onClick={handleRename}>
                        <Pen size={14} strokeWidth={1} />
                        <Typography>Rename</Typography>
                    </MenuItem>
                    <MenuItem onClick={handleDelete}>
                        <Trash size={14} strokeWidth={1} color="red" />
                        <Typography>Delete</Typography>
                    </MenuItem>
                </Menu>
            </ClickAwayListener>
        </>
    );
};
